import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { find, map, take, union, assign, filter, isNil } from 'lodash';
import { TeaserAsset } from '@app/shared/models/teaser-asset';

@Injectable({
  providedIn: 'root',
})
export class TeaserAssetStoreService {
  public readonly maxAssetCount = 5;

  private _assets: BehaviorSubject<TeaserAsset[]> = new BehaviorSubject<TeaserAsset[]>([]);
  private get assets() {
    return this._assets.getValue();
  }
  public readonly assets$ = this._assets.asObservable();

  private _selectedAsset: BehaviorSubject<TeaserAsset> = new BehaviorSubject<TeaserAsset>({} as TeaserAsset);
  public readonly selectedAsset$ = this._selectedAsset.asObservable();

  init = (assets: TeaserAsset[]) => {
    if (assets.length === 0) {
      assets = [{ index: 0, type: null, asset: null, src: null }];
    }
    this._assets.next(assets);
    this._selectedAsset.next(this.assets[0]);
  };

  select = (asset: TeaserAsset) => this._selectedAsset.next(find(this.assets, (a) => a.index === asset.index) as TeaserAsset);

  add = (): TeaserAsset => {
    const newAsset = { index: this.assets.length, type: null, asset: null, src: null };
    this._assets.next(take(union(this.assets, [newAsset]), this.maxAssetCount));
    return newAsset;
  };

  remove = (asset: TeaserAsset) => {
    if (isNil(asset.asset)) {
      this._assets.next(
        map(
          filter(this.assets, (a) => a.index !== asset.index),
          (a, i) => assign(a, { index: i }),
        ),
      );
    } else {
      this.replace(asset, { index: asset.index, type: null, asset: null, src: null });
    }
  };

  replace = (oldAsset: TeaserAsset, newAsset: TeaserAsset) => this._assets.next(map(this.assets, (a) => (a.index === oldAsset.index ? newAsset : a)));
}
